import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { BreadcrumbComponent } from '../../shared/breadcrumb/breadcrumb.component';
import { ApiService } from '../../services/api.service';
import { RouterLink } from '@angular/router';
import { isPlatformBrowser, NgFor } from '@angular/common';

@Component({
  selector: 'app-brands',
  imports: [BreadcrumbComponent, NgFor, RouterLink],
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.css']
})
export class BrandsComponent {
  currentBreadcrumb: any = ['Brand'];
  brands: any[] = [];
  groupBrands: { [key: string]: any[] } = {};
  nameArray: string[] = [];

  constructor(private api: ApiService, @Inject(PLATFORM_ID) private platformId: Object) { }

  async ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
    await this.getBrands();
  }

  async getBrands() {
    const brands = await this.api.getBrands();
    this.brands = brands.filter((item: any) => !!item.imageUrl);

    this.groupBrands = this.brands.reduce((acc: any, brand: any) => {
      const firstChar = brand.name[0].toUpperCase();
      const key = /^[0-9]$/.test(firstChar) ? '0-9' : firstChar;

      if (!acc[key]) acc[key] = [];
      acc[key].push(brand);

      return acc;
    }, {});

    this.nameArray = Object.keys(this.groupBrands).sort();
  }

  scrollToSection(letter: string) {
    if (isPlatformBrowser(this.platformId)) {
      const section = document.getElementById(letter);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
}
